import React from "react";
import { Helmet } from "react-helmet";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronDown,
  faDove,
  faHandshake,
  faStore,
  faBolt,
  faBullhorn,
  faPlaceOfWorship,
  faChartPie,
  faPuzzlePiece,
  faSignature,
} from "@fortawesome/free-solid-svg-icons";

import Home from "./views/Home";
import ThankYou from "./views/ThankYou";
import FourOhFour from "./views/FourOhFour";
import Loans from "./views/Loans";
import Grants from "./views/Grants";
import HowItWorks from "./views/HowItWorks";
import Contact from "./views/Contact";
import About from "./views/About";
import Apply from "./views/Apply";
import Terms from "./views/Terms";
import DocumentUpload from "./views/DocumentUpload";
import NoApplicationFound from "./views/NoApplicationFound";
import Finished from "./views/Finished";
import Investors from "./views/Investors";
import Benefits from "./views/Benefits";
import CharityShopLoan from "./views/CharityShopLoan";
import Privacy from "./views/Privacy";
import CookiePolicy from "./views/CookiePolicy";
import AcceptableUse from "./views/AcceptableUse";
import CookieSettings from "./views/CookieSettings";
import { ldJson } from "./core/constants";
import JupiterLogin from "./views/jupiter/Login";
import JupiterDashboard from "./views/jupiter/Dashboard";
import SharedSecretChallenge from "./views/jupiter/SharedSecretChallenge";
import MFARespond from "./views/jupiter/MFARespond";
import JupiterViewApplication from "./views/jupiter/ViewApplication";
import JupiterViewDocument from "./views/jupiter/ViewDocument";
import JupiterUsers from "./views/jupiter/Users";

import "./styles/app.css";

library.add(
  faChevronDown,
  faDove,
  faHandshake,
  faStore,
  faBolt,
  faBullhorn,
  faPlaceOfWorship,
  faChartPie,
  faPuzzlePiece,
  faSignature
);

export default function App() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnVisibilityChange
        draggable={false}
        pauseOnHover
        rtl={false}
      />
      <Helmet>
        <title>
          Interest Free Loans &middot; ZeroPA &middot; Disrupting lending with
          zero interest
        </title>
        <meta
          name="description"
          content="ZeroPA offers zero-interest loans for white goods, food and utilities. We're disrupting traditional lending with simple, transparent, interest-free borrowing."
        />
        <meta
          name="keywords"
          content="interest-free loans, zero interest lending, no interest loan, debt-free, personal finance, grants, emergency financial help"
        />
        <meta property="og:title" content="Interest-Free Loans from ZeroPA" />
        <meta
          property="og:description"
          content="ZeroPA offers zero-interest loans for white goods, food and utilities. We're disrupting traditional lending with simple, transparent, interest-free borrowing."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://zeropa.co.uk" />
        <meta
          property="og:image"
          content="https://zeropa.s3.eu-west-1.amazonaws.com/zeropa-og.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Interest-Free Loans from ZeroPA" />
        <meta
          name="twitter:description"
          content="ZeroPA offers zero-interest loans for white goods, food and utilities. We're disrupting traditional lending with simple, transparent, interest-free borrowing."
        />
        <meta
          name="twitter:image"
          content="https://zeropa.co.uk/zeropa-og.jpg"
        />
        <link rel="canonical" href="https://zeropa.co.uk" />
        <script type="application/ld+json">{JSON.stringify(ldJson)}</script>
      </Helmet>
      <Routes>
        <Route path="*" element={<FourOhFour />} />
        <Route path="/" element={<Home />} />
        <Route path="/thanks" element={<ThankYou />} />
        <Route path="/loans" element={<Loans />} />
        <Route path="/grants" element={<Grants />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/apply/:id/:hash" element={<DocumentUpload />} />
        <Route path="/apply/:id/:hash/finished" element={<Finished />} />
        <Route path="/no-application" element={<NoApplicationFound />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/terms/privacy" element={<Privacy />} />
        <Route path="/terms/cookies" element={<CookiePolicy />} />
        <Route path="/cookie-settings" element={<CookieSettings />} />
        <Route path="/terms/acceptable-use" element={<AcceptableUse />} />
        <Route path="/investors" element={<Investors />} />
        <Route path="/benefits" element={<Benefits />} />
        <Route path="/charityshoploan" element={<CharityShopLoan />} />
        <Route path="/jupiter" element={<JupiterLogin />} />
        <Route path="/jupiter/dashboard" element={<JupiterDashboard />} />
        <Route
          path="/jupiter/applications/:id"
          element={<JupiterViewApplication />}
        />
        <Route
          path="/jupiter/view-document"
          element={<JupiterViewDocument />}
        />
        <Route path="/jupiter/users" element={<JupiterUsers />} />
        <Route path="/jupiter/mfa" element={<MFARespond />} />
        <Route
          path="/jupiter/shared-secret"
          element={<SharedSecretChallenge />}
        />
      </Routes>
    </>
  );
}
